/*
 * This Component is on the <PersonalAndClassStates /> Component
 * The <PersonalAndClassStats /> is on the SearchByName Component
 */

import React, { useState }    from 'react'
import Button                 from '@material-ui/core/Button'
import Container              from '@material-ui/core/Container'
import Grid                   from '@material-ui/core/Grid'
import PropTypes              from 'prop-types'
import { store }              from '../../Redux/Store'
import TextField              from '@material-ui/core/TextField'
import Typography             from '@material-ui/core/Typography'

const ClassLeader = ({ editClick, editItem, handleFocus, handleSearch }) => {

   const [ displayName, setDisplayName ] = useState('')

   const { classData } = store.getState()

   const editLocalClick = (e) => {
      editClick(e)
   }

   const handleLocalSearch = (e) => {
      handleSearch(e)
      setDisplayName(e.target.value)
      handleFocus()
   }

   return (

   <Container >
      <Grid container >
         <Grid item xs={12} sm={5}>
            <Typography variant='h6' style={{marginTop: '1rem', textAlign: 'left'}} >
               Class Leader Name
            </Typography>
         </Grid>
         {classData.classLeader
            ?
               <Grid item xs={12} sm={6}>
                  <Typography variant='h6' style={{marginTop: '1rem', textAlign: 'left'}} >
                     {classData.classLeader.classLeaderName}
                     <Button data-testid='class-leader-edit-button' onClick={() => editLocalClick({ editItem: 'classLeader' })} style={{marginLeft: '2rem'}}>
                        Edit
                     </Button>
                  </Typography>
               </Grid>
            :
               <Grid item xs={12} sm={6}>
                  <Typography variant='h6' style={{marginTop: '1rem', textAlign: 'left'}} >
                     Unknown
                     <Button onClick={() => editLocalClick({ editItem: 'classLeader' })} style={{marginLeft: '2rem'}}>
                        Edit
                     </Button>
                  </Typography>
               </Grid>
         }
         {editItem === 'classLeader'
            ?
               <Grid item xs={7}>
                     <TextField
                        name='search-for-class-leader-input'
                        label='Search for Class Leader'
                        onFocus={handleLocalSearch}
                        onChange={handleLocalSearch}
                        style={{width: '100%', marginLeft: '0.3rem'}}
                        value={displayName}
                        variant='outlined'
                     />
               </Grid>
            :
               null
         }
      </Grid>
   </Container>
   )
}

ClassLeader.propTypes = {
   editClick: PropTypes.func,
   editItem: PropTypes.string,
   handleFocus: PropTypes.func,
   handleSearch: PropTypes.func
 }

export default ClassLeader
